import React from 'react';
import './i18n';
import Flag from 'react-world-flags'
import { useTranslation } from 'react-i18next';
import { switchLanguage } from './languageRouting';

const languages = [
    { code: 'en', flag: 'us' },
    { code: 'fr', flag: 'fr' },
    { code: 'ua', flag: 'ua' },
    { code: 'si', flag: 'SI' }
];

function ChangeLangue() {
    const { i18n } = useTranslation();

    const changeLanguage = (language) => {
        switchLanguage(i18n, language);
    };

    const currentLanguage = i18n.language;

    return (
        <ul className="lang">
            {languages.map(({ code, flag }) => (
                <li
                    key={code}
                    className={currentLanguage === code ? 'active' : ''}
                    onClick={() => changeLanguage(code)}
                >
                    <Flag code={flag} />
                </li>
            ))}
        </ul>
    );
}

export default ChangeLangue;
